// extracted by mini-css-extract-plugin
module.exports = {"otherBG":"index_otherBG__sBYKg","liveAuctionBG":"index_liveAuctionBG__2IOVW"};